import {Injectable} from '@angular/core'


export interface AppLogger {
  debug: (funcName: string, ...args: unknown[]) => void
  info: (funcName: string, ...args: unknown[]) => void
  warn: (funcName: string, ...args: unknown[]) => void
  error: (funcName: string, ...args: unknown[]) => void
}

@Injectable({providedIn: 'root'})
export class LoggerService {
  create(context: string): AppLogger {
    const prefix = `${context}#`

    return {
      debug: (funcName: string, ...args: unknown[]) => console.debug(`${prefix}${funcName}:`, ...args),
      info: (funcName: string, ...args: unknown[]) => console.info(`${prefix}${funcName}:`, ...args),
      warn: (funcName: string, ...args: unknown[]) => console.warn(`${prefix}${funcName}:`, ...args),
      error: (funcName: string, ...args: unknown[]) => console.error(`${prefix}${funcName}:`, ...args),
    }
  }
}
